module.exports = __webpack_public_path__ + "img/europeanunion.06c8e078.svg";